import { render, staticRenderFns } from "./punchList.vue?vue&type=template&id=474a4042&scoped=true&"
import script from "./punchList.vue?vue&type=script&lang=js&"
export * from "./punchList.vue?vue&type=script&lang=js&"
import style0 from "./punchList.vue?vue&type=style&index=0&id=474a4042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a4042",
  null
  
)

export default component.exports